<template>
  <div class="landing-prices">
    <h2 class="h2 text-center mb-4 mb-sm-6 mb-md-8 mb-lg-15">
      {{ $t('prices') }}
    </h2>
    <!--<div class="text-center d-md-flex align-center justify-center mb-md-8">
        &lt;!&ndash;<div class="landing__icon">
          <svg class="mb-2" width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.66406 17.234H32.1353V14.234H8.66406V17.234ZM36.6353 21.734V32.3533H39.6353V21.734H36.6353ZM32.1353 36.8534H8.66407V39.8534H32.1353V36.8534ZM4.16406 32.3534V21.734H1.16406V32.3534H4.16406ZM8.66407 36.8534C6.17879 36.8534 4.16406 34.8386 4.16406 32.3534H1.16406C1.16406 36.4955 4.52193 39.8534 8.66407 39.8534V36.8534ZM36.6353 32.3533C36.6353 34.8386 34.6206 36.8534 32.1353 36.8534V39.8534C36.2774 39.8534 39.6353 36.4955 39.6353 32.3533H36.6353ZM32.1353 17.234C34.6206 17.234 36.6353 19.2487 36.6353 21.734H39.6353C39.6353 17.5919 36.2774 14.234 32.1353 14.234V17.234ZM8.66406 14.234C4.52192 14.234 1.16406 17.5919 1.16406 21.734H4.16406C4.16406 19.2487 6.17878 17.234 8.66406 17.234V14.234Z" fill="white" /><path d="M10.8102 22.6659C10.9397 21.8477 11.7081 21.2895 12.5263 21.4191L41.6347 26.0294C42.453 26.159 43.0112 26.9273 42.8816 27.7456L40.2818 44.1603C40.1522 44.9785 39.3838 45.5368 38.5656 45.4072L9.4572 40.7969C8.63897 40.6673 8.08072 39.8989 8.21031 39.0807L10.8102 22.6659Z" stroke="white" stroke-width="3" /><path d="M2.66406 18.7339C2.66406 17.077 4.00721 15.7339 5.66406 15.7339H35.2098C36.8666 15.7339 38.2098 17.077 38.2098 18.7339V35.3026C38.2098 36.9595 36.8666 38.3026 35.2098 38.3026H5.66406C4.0072 38.3026 2.66406 36.9595 2.66406 35.3026V18.7339Z" fill="#9DE5EF" stroke="white" stroke-width="3" /><path fill-rule="evenodd" clip-rule="evenodd" d="M3.22656 22.4081H38.2126V19.4081H3.22656V22.4081ZM8.17685 25.8897C7.62456 25.8897 7.17685 26.3374 7.17685 26.8897V31.0961C7.17685 31.6484 7.62456 32.0961 8.17685 32.0961H12.3832C12.9355 32.0961 13.3832 31.6484 13.3832 31.0961V26.8897C13.3832 26.3374 12.9355 25.8897 12.3832 25.8897H8.17685Z" fill="white" /></svg>
        </div>&ndash;&gt;
        <div>
          <span
            :class="{ 'primary&#45;&#45;text pseudo-link' : pricesTab !== 1 }"
            class="display-2 mx-3 ml-md-6"
            @click="pricesTab = 1"
          >
            {{ $t('prices') }}
          </span>
          <span
            :class="{ 'primary&#45;&#45;text pseudo-link' : pricesTab !== 2 }"
            class="display-2 mx-3 ml-md-6 d-none"
            @click="pricesTab = 2"
          >
            {{ $t('calculator') }}
          </span>
        </div>
      </div>-->
    <PricesTable v-show="pricesTab === 1" class="landing__prices" />
    <Calculator v-show="pricesTab === 2" class="landing__prices" />
    <VBtn
      class="d-flex button-start mt-12 mt-lg-14"
      color="success"
      dark
      x-large
      @click="$vuetify.goTo('#register-form')"
    >
      {{ $t('signUp') }}
    </VBtn>
  </div>
</template>

<script>

import PricesTable from './PricesTable.vue';
import Calculator from './Calculator.vue';

export default {
  name: 'LandingPrices',
  components: { Calculator, PricesTable },
  data() {
    return {
      pricesTab: 1,
    };
  },
};


</script>

<style scoped lang="scss">
  .landing-prices {
    padding-top: 3rem;
    margin-bottom: 176px;
  }
  .button-start {
    width: 267px;
    margin: 0 auto;
  }
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .landing-prices {
    margin-bottom: 100px;
  }
}
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .landing-prices {
      padding-top: 1.5rem;
      margin-bottom: 70px;
    }
  }
@media #{map-get($display-breakpoints, 'xs-only')} {
  .landing-prices {
    margin-bottom: 50px;
  }
  .button-start {
    width: 100%;
    max-width: 300px;
  }
}

</style>

<i18n locale="en" lang="yaml">
  prices: Prices
  calculator: Calculator
  signUp: Get started with Huntica
</i18n>

<i18n locale="ru" lang="yaml">
  prices: Тарифы
  calculator: Калькулятор
  signUp: Начать работу с Huntica
</i18n>
